import { FC, useState } from "react";
import { Box, styled } from "@mui/system";
import muiIcons from "../icons/mui-icons";
import { GullButton } from "../buttons/GullButton";
import { H3, Paragraph } from "../Typography";
import { SubmitHandler, useForm } from "react-hook-form";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import useCommonContext from "../../hooks/useCommonContext";
import ComposeForm from "../forms/ComposeForm";

const DialogHeader = styled(Box)(({ theme }) => ({
  padding: "1rem 1.5rem",
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const FormFooter = styled(Box)(({ theme }) => ({
  padding: "1rem 1.5rem",
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const ComposeModal: FC = () => {
  const { CloseIcon, CircleCheckMarkIcon } = muiIcons;
  const { composeFormModal, setComposeFormModal } = useCommonContext();
  const [successModal, setSuccessModal] = useState(false);
  const handleClose = () => {
    setSuccessModal(false);
    setComposeFormModal(false);
  };

  type Inputs = {
    email: string;
    description?: string;
  };
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    console.log(data);
    if (data) {
      setSuccessModal(true);
      reset();
    }
  };

  return (
    <>
      <Dialog open={composeFormModal} onClose={handleClose}>
        <DialogHeader>
          <H3>Add new customer</H3>
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </DialogHeader>

        <DialogContent sx={{ pb: 0 }}>
          <ComposeForm
            handleClose={handleClose}
            setSuccessModal={setSuccessModal}
            register={register}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            errors={errors}
          />
        </DialogContent>

        <FormFooter>
          <GullButton
            variant="contained"
            color="warning"
            onClick={handleClose}
            sx={{ p: ".5rem 1rem", fontSize: 16 }}
          >
            Cancel
          </GullButton>
          <GullButton
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
            sx={{ p: ".5rem 1rem", fontSize: 16 }}
          >
            Submit
          </GullButton>
        </FormFooter>
      </Dialog>

      <Dialog open={successModal}>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "2rem 4rem",
          }}
        >
          <CircleCheckMarkIcon
            sx={{
              mt: "10px",
              color: "primary.main",
              fontSize: 90,
            }}
          />
          <Paragraph sx={{ py: "20px", fontSize: 18 }}>
            Email has been successfully submitted
          </Paragraph>
          <GullButton
            color="primary"
            variant="contained"
            onClick={handleClose}
            sx={{
              mt: "10px",
              p: ".5rem 1rem",
              fontSize: 16,
            }}
          >
            Close
          </GullButton>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ComposeModal;
